import { Link } from "react-router-dom";
import WalletModal from "../modals/WalletModal";
import { useEffect, useState, useContext } from "react";
import { ConnectionStatusContext } from "../../provider/ConnectionStatusProvider";

const HeroSection = () => {
  const connectionStatus = useContext(ConnectionStatusContext);
  const [auth, setAuth] = useState<any>(false);
  const [account, setAccounts] = useState<any>(null);
  const [balance, setBalance] = useState<any>(null);

  function getValue(
    dictionary: { [key: string]: number },
    key: string
  ): number | string {
    console.log("Received key:", key);
    console.log("Dictionary keys:", Object.keys(dictionary));

    if (key in dictionary) {
      console.log("Key found:", key, dictionary);
      return dictionary[key];
    } else {
      console.log("Key not found:", key);
      return "Key not found";
    }
  }

  useEffect(() => {
    if (connectionStatus) {
      setAuth(connectionStatus?.isConnected);
      if (connectionStatus?.type === "xverse") {
        setAccounts(
          connectionStatus?.accounts.find((v) => v.purpose === "ordinals")
        );
      } else {
        setAccounts(connectionStatus?.accounts);
      }

      // setAccounts(connectionStatus?.accounts);
    }
  }, [connectionStatus]);

  useEffect(() => {
    if (account && connectionStatus) {
      const balance =
        connectionStatus?.type === "xverse"
          ? getValue(connectionStatus?.balance, account.address)
          : connectionStatus?.balance;

      setBalance(balance);
    }
  }, [account, connectionStatus]);

  return (
    <section
      id="hero-section"
      className="-mt-36 pt-36 pb-20 relative overflow-hidden"
    >
      <div className="container mx-auto pt-6 px-4">
        <div className="relative mb-8 p-8 bg-gray-900 overflow-hidden rounded-3xl">
          <div className="absolute top-1/2 left-1/2 min-w-max transform -translate-x-1/2 -translate-y-1/2">
            <div className="absolute bg-gradient-radial-dark w-full h-full" />
            <img src="/assets/images/pattern-dark.png" alt=".." />
          </div>
          <div
            className="relative flex flex-wrap lg:items-center -m-8"
            data-aos="fade-up"
          >
            <div className="w-full md:w-1/2 p-8">
              <div className="md:max-w-lg mx-auto">
                <h1 className="font-heading mb-6 text-4xl lg:text-5xl text-white font-black tracking-tight">
                  Unlock the Full Potential of{" "}
                  <span className="text-color">Your NFTs with SoftStake</span>
                </h1>
                <p className="mb-8 text-xl text-gray-300 font-bold">
                  Stake. Earn. Grow. Experience effortless NFT staking and watch
                  your digital assets generate real value.
                </p>
                <div className="flex flex-wrap -m-2">
                  <div className="w-full md:w-auto p-2">
                    <div data-aos="fade-up" data-aos-delay="200">
                      {auth ? (
                        <Link
                          to="/dashboard"
                          className="block group relative font-heading px-6 py-3 w-full uppercase text-white font-semibold tracking-px bg-gradient-to-bl from-primary to-primaryHover overflow-hidden rounded-md transition-transform duration-500 active:scale-105"
                        >
                          <div className="absolute top-0 left-0 transform -translate-x-full group-hover:-translate-x-0 h-full w-full transition ease-in-out duration-500 bg-primaryHover" />
                          <p className="relative z-10">Stake Ordinal</p>
                        </Link>
                      ) : (
                        <WalletModal title="Stake Ordinal" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="w-full md:w-1/2 p-8"
              data-aos="fade-left"
              // data-aos-delay="300"
            >
              <div className="max-w-max xl:min-h-[37rem] max-h-[37rem] mx-auto md:mr-0 bg-white overflow-hidden rounded-3xl">
                <img
                  className="mx-auto h-full w-full"
                  src="/assets/images/hero-image.jpeg"
                  alt=".."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
